import React from 'react';
import Footer from '../components/footer/Footer';
import Terns from '../components/terns/Terns';
import Header from '../components/header/Header';

const terns_ = () => {
    return (
        <>
            <Header/>
            <Terns />
            <Footer/>
        </>
    );
};

export default terns_;